import { VStack, Text, Heading, ScrollView, Spinner } from 'native-base';
import { PrimaryButton, ModalWrapper, UserAvatar } from '../../';
import { useDispatch } from 'react-redux';
import { openModal, useGetCurrentUserQuery } from '@breakroom-nx/redux';
import { theme } from '@breakroom-nx/assets';

const fullAccountBenefits = [
  'Create your own username.',
  'Add friends.',
  'Gain points for contributing to the community. You will be able to use them in the future to personalize your experience on the platform.',
  'Toggle anonymous mode anytime you want.',
  'All your existing information and chats will be ported to your full account.',
];

export const AccountConversion = ({ route, navigation }: any) => {
  const { data: currentUser, isLoading: isLoadingUser } =
    useGetCurrentUserQuery();

  const dispatch = useDispatch();
  return (
    <ModalWrapper>
      <VStack space={5}>
        <VStack
          bg={'surface.100'}
          textAlign={'center'}
          style={{
            borderColor: theme.colors.surface[200],
            borderWidth: 1,
            borderRadius: 25,
            shadowColor: theme.colors.surface[100],
            shadowOpacity: 0.25,
            shadowRadius: 20,
            shadowOffset: {
              width: 10,
              height: 20,
            },
            padding: 30,
          }}
        >
          {isLoadingUser ? (
            <Spinner size={'sm'} />
          ) : (
            <VStack space={3}>
              <UserAvatar
                disabled
                noBorder
                noMargin
                uid={currentUser?.uid ?? ''}
                size={100}
              />
              <Heading fontSize={30} lineHeight={34}>
                <Text color={'white'}>
                  Ready for More,{' '}
                  <Text color={currentUser?.theme ?? theme.colors.yellow[200]}>
                    {currentUser?.username}
                  </Text>
                  ?
                </Text>
              </Heading>
              <Text color={'surface.600'} fontSize={16}>
                You are currently using a temporary account to check out the
                app. We love our anonymous users, but if you're thinking about
                sticking around, why not create a full account?
              </Text>
            </VStack>
          )}
        </VStack>

        <ScrollView
          flex={1}
          maxHeight={'40vh'}
          showsVerticalScrollIndicator={true}
          _contentContainerStyle={{
            pb: 8,
          }}
        >
          <VStack
            bg={'surface.100'}
            space={3}
            textAlign={'center'}
            style={{
              borderColor: theme.colors.surface[200],
              borderWidth: 1,
              borderRadius: 25,
              shadowColor: theme.colors.surface[100],
              shadowOpacity: 0.25,
              shadowRadius: 20,
              shadowOffset: {
                width: 10,
                height: 20,
              },
              padding: 30,
            }}
          >
            <VStack space={'5'}>
              <VStack alignItems={'flex-start'} space={5}>
                <Text fontWeight={'bold'}>Full Account Benefits</Text>
                <VStack space={2} ml={3} alignItems={'flex-start'}>
                  {fullAccountBenefits.map((benefit, index) => {
                    return (
                      <Text
                        color={'surface.600'}
                        textAlign={'left'}
                        key={index}
                      >{`• ${benefit}`}</Text>
                    );
                  })}
                </VStack>
              </VStack>

              <VStack width={'full'} space={5}>
                <PrimaryButton
                  text="Create Account"
                  disabled={isLoadingUser}
                  onPress={() => {
                    // navigation.goBack();
                    // navigation.navigate('Signup', {
                    //   isAnonymous: true,
                    //   username: currentUser?.username,
                    // });
                  }}
                />
                <PrimaryButton
                  disabled={isLoadingUser}
                  text="Sign Out & Delete Account"
                  bg={'red.400'}
                  onPress={() => {
                    dispatch(openModal({ modalType: 'AccountDeletion' }));
                  }}
                />
              </VStack>
            </VStack>
          </VStack>
        </ScrollView>
      </VStack>
    </ModalWrapper>
  );
};
